import { Box, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { toCssValue } from '../../../../../../../core/utils/theme.utils';

interface Props {}

const ConnectionsLegend: React.FC<Props> = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box className={classes.legendContainer}>
      <Box className={classes.legendBox}>
        <Box className={`${classes.divider} ${classes.currentWeak}`} />
        <Typography>{t('connections:legend:currentWeak')}</Typography>
      </Box>
      <Box className={classes.legendBox}>
        <Box className={`${classes.divider} ${classes.currentStrong}`} />
        <Typography>{t('connections:legend:currentStrong')}</Typography>
      </Box>
      <Box className={classes.legendBox}>
        <Box className={`${classes.divider} ${classes.historicalWeak}`} />
        <Typography>{t('connections:legend:historicalWeak')}</Typography>
      </Box>
      <Box className={classes.legendBox}>
        <Box className={`${classes.divider} ${classes.historicalStrong}`} />
        <Typography>{t('connections:legend:historicalStrong')}</Typography>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  legendContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    marginLeft: -theme.spacing(2),
  },
  legendBox: {
    display: 'flex',
    alignItems: 'center',
    padding: toCssValue([theme.spacing(1), theme.spacing(0)]),
    '& p': {
      fontSize: '13px',
      marginLeft: theme.spacing(4),
    },
  },
  divider: {
    width: '45px',
  },
  historicalWeak: {
    height: '1px',
    background: `repeating-linear-gradient(to right,${theme.palette.secondary.light} 0,${theme.palette.secondary.light} 8px,transparent 8px,transparent 12px)`,
  },
  historicalStrong: {
    height: '3px',
    background: `repeating-linear-gradient(to right,${theme.palette.secondary.light} 0,${theme.palette.secondary.light} 8px,transparent 8px,transparent 12px)`,
  },
  currentWeak: {
    height: '1px',
    background: `repeating-linear-gradient(to right,${theme.palette.secondary.light} 0,${theme.palette.secondary.light} 8px)`,
  },
  currentStrong: {
    height: '3px',
    background: `repeating-linear-gradient(to right,${theme.palette.secondary.light} 0,${theme.palette.secondary.light} 8px)`,
  },
}));

export default ConnectionsLegend;
